/** Query keys copied onto internal links. Click ids included so a paid visit is not lost on the next page. */
export const FORWARDED_PARAM_KEYS: readonly string[] = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'email',
  'affiliate',
  'affiliateCode',
  'referral',
  'discount',
  'sscid',
  'irclickid',
  'click_id',
  'flow',
  'gclid',
  'fbclid',
  'gbraid',
  'wbraid',
  'gclsrc',
  'gad_source',
  'gad_campaignid',
  // Reddit click id. Forwarded to the Shopify checkout the same way gclid is,
  // so it lands on the order as attributes[rdt_cid] for Reddit CAPI matching.
  'rdt_cid',
] as const;
